export const data =[
  {
    id: 1,
    title:'// Home',
    url : '/'
  },
  {
    id: 2,
    title:' // Expertise',
    url : '/expertise'
  },
  {
    id: 3,
    title:' // Work',
    url : '/project'
  },
  {
    id: 4,
    title:'// Experience',
    url : '/experience'
  },
  {
    id: 5,
    title:'// Contact',
    url : '/contact'
  },
]